export const parseQuery = (uriParams) => {
  const queryArray = decodeURIComponent(uriParams).substring(1).split('&')
  const query = {}

  queryArray.map(item => {
    const keyValue = item.split('=')
    query[keyValue[0]] = keyValue[1]

    return item
  })

  return query
}